<!-- An expanding impact ring, played once on mount. Colored by --reveal-hue. -->
<div class="shockwave" aria-hidden="true"></div>

<style lang="postcss">
  .shockwave {
    position: absolute;
    top: 50%;
    left: 50%;
    animation: shockwave 700ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
    margin: -5rem;
    border: 3px solid color-mix(in oklab, var(--reveal-hue) 80%, white);
    border-radius: 50%;
    box-shadow:
      0 0 2rem color-mix(in oklab, var(--reveal-hue) 60%, transparent),
      inset 0 0 1.5rem color-mix(in oklab, var(--reveal-hue) 40%, transparent);
    aspect-ratio: 1;
    width: 10rem;
    pointer-events: none;
  }
  @keyframes shockwave {
    from {
      transform: scale(0.15);
      opacity: 1;
    }
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .shockwave {
      display: none;
    }
  }
</style>
